import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { formatDate, isAfter, isBefore, isSameDay, isThisYear } from 'date-fns';
import { format } from 'path';
import { Event } from '../models/event.model';

@Pipe({
  name: 'eventDateTime',
  standalone: true,
})
export class EventDateTimePipe implements PipeTransform {
  datePipe = new DatePipe('nl-NL');

  transform(event: Event): string | null {
    if (!event.displayEventStartTime && !event.displayEventEndTime) {
      return null;
    }

    if (event.displayEventStartTime && !event.displayEventEndTime) {
      return `vanaf ${this.datePipe.transform(event.startDate, 'HH.mm')}`;
    } else if (event.endDate && event.displayEventEndTime && !event.displayEventStartTime) {
      return `tot ${this.datePipe.transform(event.endDate, 'HH.mm')}`;
    } else {
      var completeString = '';

      if (event.startDate) {
        completeString += `${this.datePipe.transform(event.startDate, 'HH.mm')}`;
      }

      if (event.endDate) {
        completeString += ` - ${this.datePipe.transform(event.endDate, 'HH.mm')}`;
      }

      return completeString;
    }
  }
}
